// // import { useState } from "react";

// // const EmptyItem = () => (
// //   <button className="menu-item is-empty">- Empty -</button>
// // );

// // const Item = ({ item }) => {
// //   const [isOpened, setIsOpened] = useState(false);
// //   return (
// //     <div>
// //       <button
// //         className="menu-item"
// //         onClick={() => item.children && setIsOpened(!isOpened)}
// //         style={{ color: `${item.colors}`, fontSize: "17px" }}
// //       >
// //         {item.children && (isOpened ? "🔽 " : "▶️")}
// //         {!item.children ? <span style={{ marginLeft: "22px" }}></span> : ""}

// //         {item.name}

// //         {/* {item.colors} */}
// //         {!item.children && "⭐"}

// //         {/* {console.log("children",item.children[0])} */}
// //       </button>

// //       {item.children && (
// //         <div className={`sub-menu ${isOpened ? "" : "sub-menu--shrunk"}  `}>
// //           {/* {item.children.length ? (
// //             item.children.map((subitem) => <Item item={subitem} />)
// //           ) : (
// //             <EmptyItem />
// //           )} */}
// //           {item.children.map((subitem) => (
// //             <Item item={subitem} />
// //           ))}
// //         </div>
// //       )}
// //     </div>
// //   );
// // };
// // export default Item;

// // -------------------------------------------------------------------------------------------------------------

// import { Link } from "react-router-dom";
// import { useState } from "react";

// import arrowdown from "../../../Assets/Images/Landing/arrowdown.png";
// import arrowright from "../../../Assets/Images/Landing/arrowright.png";
// import star from "../../../Assets/Images/Landing/star.png";

// const Item = ({ item }) => {
//   const [isOpened, setIsOpened] = useState(false);

//   const handleClick = () => {
//     setIsOpened(!isOpened);
//   };

//   return (
//     <div style={{ marginLeft: "7px" }}>
//       <button
//         className="menu-item"
//         onClick={handleClick}
//         style={{
//           color: `${item.colors}`,
//           fontSize: "16px",
//           display: "flex",
//           width: "80%",
//         }}
//       >
//         {/* {item.children && (isOpened ? "🔽" : "▶️")} */}
//         {item.children &&
//           (isOpened ? (
//             <img src={arrowdown} style={{ width: "13px" }} />
//           ) : (
//             <img src={arrowright} style={{ width: "11px" }} />
//           ))}

//         {item.ui_path && console.log("path",item.ui_path)}
//         {item.ui_element && console.log("elemnt",item.ui_element)}

//         {!item.children ? <span style={{ marginLeft: "10px" }}></span> : ""}
//         {item.name}
//         {/* {!item.children && "⭐"} */}
//         {!item.children && <img src={star} style={{ width: "15px"}} />}
//       </button>

//       {item.children && (
//         <div className={`sub-menu ${isOpened ? "" : "sub-menu--shrunk"}`}>
//           {item.children.map((subitem) => (
//             <Item key={subitem.name} item={subitem} />
//           ))}
//         </div>
//       )}

//       {/* If the item has no children, render a Link */}
//       {/* {!item.children && (
//         <Link to={`/pages/${item.name}`} className="page-link">
//           {item.name}
//         </Link>
//       )} */}
//     </div>
//   );
// };

// export default Item;

// -------------------------------------------------------------------------------------------------------------
// working routes
// import { Link } from "react-router-dom";
// import { useState } from "react";

// import arrowdown from "../../../Assets/Images/Landing/arrowdown.png";
// import arrowright from "../../../Assets/Images/Landing/arrowright.png";
// import star from "../../../Assets/Images/Landing/star.png";

// const Item = ({ item }) => {
//   const [isOpened, setIsOpened] = useState(false);

//   const handleClick = () => {
//     setIsOpened(!isOpened);
//   };

//   const renderLeaf = () => {
//     // If there's a ui_path, wrap the name and star in a Link component
//     if (item.ui_path) {
//       return (
//         <Link to={item.ui_path} style={{ display: "flex", alignItems: "center", color: `${item.colors}` }}>
//           {item.name}
//           <img src={star} style={{ width: "15px", marginLeft: "5px" }} />
//         </Link>
//       );
//     } else {
//       // If there's no ui_path, render the name and star as before
//       return (
//         <>
//           {item.name}
//           <img src={star} style={{ width: "15px", marginLeft: "5px" }} />
//         </>
//       );
//     }
//   };

//   return (
//     <div style={{ marginLeft: "7px" }}>
//       <div
//         className="menu-item"
//         onClick={handleClick}
//         style={{
//           color: `${item.colors}`,
//           fontSize: "16px",
//           display: "flex",
//           alignItems: "center",
//           width: "80%",
//           cursor: "pointer", // Added for better UX
//         }}
//       >
//         {item.children ? (
//           isOpened ? (
//             <img src={arrowdown} style={{ width: "13px" }} />
//           ) : (
//             <img src={arrowright} style={{ width: "11px" }} />
//           )
//         ) : null}

//         {!item.children ? renderLeaf() : item.name}
//       </div>

//       {item.children && (
//         <div className={`sub-menu ${isOpened ? "" : "sub-menu--shrunk"}`}>
//           {item.children.map((subitem) => (
//             <Item key={subitem.name} item={subitem} />
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };

// export default Item;
// =========================================================
// working routes with fonts
// import { Link } from "react-router-dom";
// import { useState } from "react";

// import arrowdown from "../../../Assets/Images/Landing/arrowdown.png";
// import arrowright from "../../../Assets/Images/Landing/arrowright.png";
// import star from "../../../Assets/Images/Landing/star.png";

// // Add an optional `level` prop with a default value of 0 to indicate the first level
// const Item = ({ item, level = 0, setPagePath }) => {
//   const [isOpened, setIsOpened] = useState(false);

//   const handleClick = () => {
//     setIsOpened(!isOpened);
//   };

//   const renderLeaf = () => {
//     if (item.ui_path) {
//       return (
//         <Link
//           to={item.ui_path}
//           style={{
//             display: "flex",
//             alignItems: "center",
//             color: `${item.colors}`,
//           }}
//         >
//           {item.name}
//           <img src={star} style={{ width: "15px", marginLeft: "5px" }} />
//         </Link>
//       );
//     } else {
//       return (
//         <>
//           {item.name}
//           <img src={star} style={{ width: "15px", marginLeft: "5px" }} />
//         </>
//       );
//     }
//   };

//   // Adjust styles based on the item level
//   const itemStyle = {
//     color: item.colors,
//     fontSize: level === 0 ? "16px" : "15.3px", // Smaller font size for child items
//     display: "flex",
//     alignItems: "center",
//     width: "80%",
//     cursor: "pointer",
//     fontWeight: level === 0 ? "600" : "normal", // Normal font weight for child items
//     marginBottom: level === 0 ? "10px" : "5px", // Less gap for child items
//   };

//   return (
//     <div style={{ marginLeft: level === 0 ? "0px" : "7px" }}>
//       {" "}
//       {/* Less margin for nested items */}
//       <div className="menu-item" onClick={handleClick} style={itemStyle}>
//         {item.children ? (
//           isOpened ? (
//             <img src={arrowdown} style={{ width: "13px" }} />
//           ) : (
//             <img src={arrowright} style={{ width: "11px" }} />
//           )
//         ) : null}

//         {!item.children ? renderLeaf() : item.name}
//       </div>
//       {item.children && (
//         <div className={`sub-menu ${isOpened ? "" : "sub-menu--shrunk"}`}>
//           {item.children.map((subitem) => (
//             // Increment `level` by 1 for each child
//             <Item key={subitem.name} item={subitem} level={level + 1} />
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };

// export default Item;
// -----------------------------------------------------------------------

// working routes with fonts and page path

// import { Link } from "react-router-dom";
// import { useState } from "react";

// import arrowdown from "../../../Assets/Images/Landing/arrowdown.png";
// import arrowright from "../../../Assets/Images/Landing/arrowright.png";
// import star from "../../../Assets/Images/Landing/star.png";
// import blankstar from "../../../Assets/Images/Landing/blankstar.png";

// const Item = ({ item, level = 0, setPagePath, hierarchy = "" }) => {
//   const [isOpened, setIsOpened] = useState(false);

//   // Adjusting the hierarchy string to include spaces around the arrow
//   const currentHierarchy = hierarchy
//     ? `${hierarchy} > ${item.name}`
//     : item.name;

//   const handleClick = () => {
//     setIsOpened(!isOpened);
//     // If the item is a leaf (has ui_path), set the page path
//     if (!item.children && item.ui_path) {
//       setPagePath(currentHierarchy);
//     }
//   };

//   const renderLeaf = () => {
//     if (item.ui_path) {
//       return (
//         <Link
//           to={item.ui_path}
//           style={{
//             display: "flex",
//             alignItems: "center",
//             color: `${item.colors}`,
//           }}
//         >
//           {item.name}
//           {/* {console.log(item,item?.my_fav,item.my_fav == 1? "hi":"" )} */}
//           {item?.my_fav == 1 ? <img src={star} style={{ width: "12px", marginTop: "-10px" }} />:<img src={blankstar} style={{ width: "12px", marginTop: "-10px" }} />}

//         </Link>
//       );
//     } else {
//       return (
//         <>
//           {item.name}
//           <img src={star} style={{ width: "12px", marginTop: "-10px" }} />
//         </>
//       );
//     }
//   };

//   const itemStyle = {
//     color: item.colors,
//     fontSize: level === 0 ? "16px" : "14.5px",
//     display: "flex",
//     alignItems: "center",
//     width: "100%",
//     cursor: "pointer",
//     fontWeight: level === 0 ? "600" : "normal",
//     marginBottom: level === 0 ? "10px" : "5px",
//     marginLeft: !item.children ? "10px" : "",
//   };

//   return (
//     <div style={{ marginLeft: level === 0 ? "0px" : "10px" }}>
//       <div className="menu-item" onClick={handleClick} style={itemStyle}>
//         {item.children ? (
//           isOpened ? (
//             <img src={arrowdown} style={{ width: "11px" }} />
//           ) : (
//             <img src={arrowright} style={{ width: "9px" }} />
//           )
//         ) : null}

//         {!item.children ? renderLeaf() : item.name}
//       </div>

//       {item.children && (
//         <div className={`sub-menu ${isOpened ? "" : "sub-menu--shrunk"}`}>
//           {item.children.map((subitem) => (
//             <Item
//               key={subitem.name}
//               item={subitem}
//               level={level + 1}
//               setPagePath={setPagePath}
//               hierarchy={currentHierarchy} // Pass the updated hierarchy with spaces around the arrow
//             />
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };

// export default Item;

// import { Link } from "react-router-dom";
// import { useState } from "react";
// import axios from "axios";

// import arrowdown from "../../../Assets/Images/Landing/arrowdown.png";
// import arrowright from "../../../Assets/Images/Landing/arrowright.png";
// import star from "../../../Assets/Images/Landing/star.png";
// import blankstar from "../../../Assets/Images/Landing/blankstar.png";

// import { useSelector } from "react-redux";

// const Item = ({ item, level = 0, setPagePath, hierarchy = "" }) => {
//   const [isOpened, setIsOpened] = useState(false);
//   const [favStatus, setFavStatus] = useState(item.my_fav);

//   const { data } = useSelector((state) => state.landing)
//   const userId = data && data.client_schema_name[6][0].user_id;
//   const clientBrId = data && data.client_schema_name[6][0].client_branch_id;

//   const toggleFavorite = async (screen_id) => {
    // REPLACED
//     // let screen_id = screen_id
//     // const URL = `https://quality.dse-cc-api.com/coaching-collaborator-api/api/v1/manage-user-favourite?operation=delete&user_id=${userId}&screen_id=${item.screen_id}&client_br_id=${clientBrId}`

//     // console.log(screen_id, URL)
//     try {
//       if (favStatus === 1) {
//         await axios.post(`https://quality.dse-cc-api.com/coaching-collaborator-api/api/v1/manage-user-favourite?operation=delete&user_id=${userId}&screen_id=${item.screen_id}&client_br_id=${clientBrId}`);
//         setFavStatus(0);
//         console.log("Deleted from favourites")
//         window.location.reload()
//       } else {
//         await axios.post(`https://quality.dse-cc-api.com/coaching-collaborator-api/api/v1/manage-user-favourite?operation=create&user_id=${userId}&screen_id=${item.screen_id}&client_br_id=${clientBrId}`);
//         setFavStatus(1);
//         console.log("Added to favourites")
//         window.location.reload()

//       }
//     } catch (error) {
//       console.error("Error updating favorite status", error);
//     }
//   };

//   const currentHierarchy = hierarchy ? `${hierarchy} > ${item.name}` : item.name;

//   const handleClick = () => {
//     setIsOpened(!isOpened);
//     if (!item.children && item.ui_path) {
//       setPagePath(currentHierarchy);
//     }
//   };

//   const renderLeaf = () => {
//     if (item.ui_path) {
//       return (
//         <Link
//           to={item.ui_path}
//           style={{
//             display: "flex",
//             alignItems: "center",
//             color: `${item.colors}`,
//           }}
//         >
//           {item.name}
//           {/* {console.log("item",item)} */}
//           <img
//             src={favStatus === 1 ? star : blankstar}
//             // style={{ width: "12px", marginTop: "-10px" }}
//             style={{ width: "13px", marginLeft:"3px" }}
//             onClick={(e) => {
//               e.preventDefault();
//               toggleFavorite(item.screen_id);
//             }}
//           />
//         </Link>
//       );
//     } else {
//       return (
//         <>
//           {item.name}
//           <img
//             src={favStatus === 1 ? star : blankstar}
//             style={{ width: "12px", marginTop: "-10px" }}
//             onClick={toggleFavorite}
//           />
//         </>
//       );
//     }
//   };

//   const itemStyle = {
//     color: item.colors,
//     fontSize: level === 0 ? "16px" : "14.5px",
//     display: "flex",
//     alignItems: "center",
//     width: "100%",
//     cursor: "pointer",
//     fontWeight: level === 0 ? "600" : "normal",
//     marginBottom: level === 0 ? "10px" : "5px",
//     marginLeft: !item.children ? "10px" : "",
//   };

//   return (
//     <div style={{ marginLeft: level === 0 ? "0px" : "10px" }}>
//       <div className="menu-item" onClick={handleClick} style={itemStyle}>
//         {item.children ? (
//           isOpened ? (
//             <img src={arrowdown} style={{ width: "11px" }} />
//           ) : (
//             <img src={arrowright} style={{ width: "9px" }} />
//           )
//         ) : null}

//         {!item.children ? renderLeaf() : item.name}
//       </div>

//       {item.children && (
//         <div className={`sub-menu ${isOpened ? "" : "sub-menu--shrunk"}`}>
//           {item.children.map((subitem) => (
//             <Item
//               key={subitem.name}
//               item={subitem}
//               level={level + 1}
//               setPagePath={setPagePath}
//               hierarchy={currentHierarchy}
//             />
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };

// export default Item;

// import { Link } from "react-router-dom";
// import { useState } from "react";
// import axios from "axios";
// import Swal from "sweetalert2"; // Import SweetAlert2

// import arrowdown from "../../../Assets/Images/Landing/arrowdown.png";
// import arrowright from "../../../Assets/Images/Landing/arrowright.png";
// import star from "../../../Assets/Images/Landing/star.png";
// import blankstar from "../../../Assets/Images/Landing/blankstar.png";
// import { API_BASE_URL } from "../../../Config/Config";

// import { useSelector } from "react-redux";

// const Item = ({ item, level = 0, setPagePath, hierarchy = "" }) => {
//   const [isOpened, setIsOpened] = useState(false);
//   const [favStatus, setFavStatus] = useState(item.my_fav);

//   const { data } = useSelector((state) => state.landing);
//   const userId = data && data.client_schema_name[6][0].user_id;
//   const clientBrId = data && data.client_schema_name[6][0].client_branch_id;

//   const toggleFavorite = async (screen_id) => {
    // REPLACED
//     try {
//       if (favStatus === 1) {
//         await axios.post(
//           `${API_BASE_URL}/coaching-collaborator-api/api/v1/manage-user-favourite?operation=delete&user_id=${userId}&screen_id=${item.screen_id}&client_br_id=${clientBrId}`
//         );
//         setFavStatus(0);
//         Swal.fire({
//           title: "Deleted!",
//           text: "Deleted from favorites",
//           icon: "success",
//           timer: 3000, // Show for 3 seconds
//           showConfirmButton: false,
//         });
//       } else {
//         await axios.post(
//           `${API_BASE_URL}/coaching-collaborator-api/api/v1/manage-user-favourite?operation=create&user_id=${userId}&screen_id=${item.screen_id}&client_br_id=${clientBrId}`
//         );
//         setFavStatus(1);
//         Swal.fire({
//           title: "Added!",
//           text: "Added to favorites",
//           icon: "success",
//           timer: 3000, // Show for 3 seconds
//           showConfirmButton: false,
//         });
//       }
//       setTimeout(() => {
//         window.location.reload();
//       }, 1300); // Delay reload by 3 seconds
//     } catch (error) {
//       console.error("Error updating favorite status", error);
//       Swal.fire({
//         title: "Error",
//         text: "Error updating favorite status",
//         icon: "error",
//         timer: 3000, // Show for 3 seconds
//         showConfirmButton: false,
//       });
//     }
//   };

//   const currentHierarchy = hierarchy ? `${hierarchy} > ${item.name}` : item.name;

//   const handleClick = () => {
//     setIsOpened(!isOpened);
//     if (!item.children && item.ui_path) {
//       setPagePath(currentHierarchy);
//     }
//   };

//   const renderLeaf = () => {
//     if (item.ui_path) {
//       return (
//         <Link
//           to={item.ui_path}
//           style={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//             width:"80%",
//             color: `${item.colors}`,
//           }}
//         >
//           {item.name}
//           <img
//             src={favStatus === 1 ? star : blankstar}
//             style={{
//               width: "13px",
//               // marginLeft: "3px"
//             }}
//             onClick={(e) => {
//               e.preventDefault();
//               toggleFavorite(item.screen_id);
//             }}
//           />
//         </Link>
//       );
//     } else {
//       return (
//         <>
//           {item.name}
//           <img
//             src={favStatus === 1 ? star : blankstar}
//             style={{ width: "12px", marginTop: "-10px" }}
//             onClick={(e) => {
//               e.preventDefault();
//               toggleFavorite(item.screen_id);
//             }}
//           />
//         </>
//       );
//     }
//   };

//   const itemStyle = {
//     color: item.colors,
//     fontSize: level === 0 ? "16px" : "14.5px",
//     display: "flex",
//     alignItems: "center",
//     width: "100%",
//     cursor: "pointer",
//     fontWeight: level === 0 ? "600" : "normal",
//     marginBottom: level === 0 ? "10px" : "5px",
//     marginLeft: !item.children ? "10px" : "",
//   };

//   return (
//     <div style={{ marginLeft: level === 0 ? "0px" : "10px" }}>
//       <div className="menu-item" onClick={handleClick} style={itemStyle}>
//         {item.children ? (
//           isOpened ? (
//             <img src={arrowdown} style={{ width: "11px" }} />
//           ) : (
//             <img src={arrowright} style={{ width: "9px" }} />
//           )
//         ) : null}
//         {!item.children ? renderLeaf() : item.name}
//       </div>

//       {item.children && (
//         <div className={`sub-menu ${isOpened ? "" : "sub-menu--shrunk"}`}>
//           {item.children.map((subitem) => (
//             <Item
//               key={subitem.name}
//               item={subitem}
//               level={level + 1}
//               setPagePath={setPagePath}
//               hierarchy={currentHierarchy}
//             />
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };

// export default Item;

// THE ABOVE CODE IS PREVIOS VERSION OF THIS CODE, THE CODE BELOW IS OLDER THAN THAT

import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import Swal from "sweetalert2"; // Import SweetAlert2
import arrowdown from "../../../Assets/Images/Landing/arrowdown.png";
import arrowright from "../../../Assets/Images/Landing/arrowright.png";
import star from "../../../Assets/Images/Landing/star.png";
import blankstar from "../../../Assets/Images/Landing/blankstar.png";
import { API_BASE_URL } from "../../../Config/Config";

import { useSelector } from "react-redux";
import favoritesEvents from "../../../Utils/favoritesEvents";
import Colors from "../../../Constants/Colors";
import "../MenuTreeStructure.css";
import arrowRightLevel2 from "../../../Assets/Images/CommanImages/Rectangle 36.png";
import EndPoints from "../../../Api/Endpoints";
import { POST } from "../../../Api/HttpsMethods";
const Item = ({
  selectedLvl1,
  setSelectedLvl1,
  item,
  level = 0,
  setPagePath,
  hierarchy = "",
}) => {
  const [isOpened, setIsOpened] = useState(false);
  const [favStatus, setFavStatus] = useState(item.my_fav);

  const { data } = useSelector((state) => state.landing);
  const userId = data && data.client_schema_name[6][0].user_id;
  const clientId = data && data.client_schema_name[6][0].client_id;
  const clientBrId = data && data.client_schema_name[6][0].client_branch_id;

  // Listen for fav changes emitted by Favorites dropdown (remove) or other Items (add/remove)
  useEffect(() => {
    const unsubscribeRemove = favoritesEvents.on('favoriteRemoved', (screenId) => {
      if (item.screen_id === screenId) {
        setFavStatus(0);
      }
    });

    const unsubscribeAdd = favoritesEvents.on('favoriteAdded', (screenId) => {
      if (item.screen_id === screenId) {
        setFavStatus(1);
      }
    });

    return () => {
      unsubscribeRemove();
      unsubscribeAdd();
    };
  }, [item.screen_id]);

  const toggleFavorite = async (screen_id) => {
    try {
      if (favStatus === 1) {
        await POST.withToken(
          `${EndPoints.PRIM_MANAGE_USER_FAVOURITE}?operation=delete&user_id=${userId}&screen_id=${item.screen_id}&client_br_id=${clientBrId}`,
          {}
        );
        setFavStatus(0);
        favoritesEvents.removeFavorite(item.screen_id);
      } else {
        await POST.withToken(
          `${EndPoints.PRIM_MANAGE_USER_FAVOURITE}?operation=create&user_id=${userId}&screen_id=${item.screen_id}&client_br_id=${clientBrId}`,
          {}
        );
        setFavStatus(1);
        favoritesEvents.addFavorite(item.screen_id);
      }
    } catch (error) {
      console.error("Error updating favorite status", error);
    }
  };

  const currentHierarchy = hierarchy
    ? `${hierarchy} > ${item.name}`
    : item.name;

  const handleClick = () => {
    setIsOpened(!isOpened);
    if (!item.children && item.ui_path) {
      setPagePath(currentHierarchy);
    }
  };

  const handleLevel1Click = (e) => {
    e.stopPropagation();
    // Single click: select this Level 1
    if (level === 0) setSelectedLvl1(item.name);
    handleClick();
  };

  const handleLevel1DoubleClick = (e) => {
    e.stopPropagation();
    // Double click: deselect Level 1
    if (level === 0) setSelectedLvl1(null);
    // Optionally: also collapse, etc.
  };
  // Style for Level 1 with margin for image
  const lvl1ImageStyle =
    level === 0
      ? { marginLeft: "12px", marginRight: "10px", width: "20px" }
      : { width: "20px" };

  const renderLeaf = () => {
    if (item.ui_path) {
      return (
        <Link
          to={item.ui_path}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "71%",
            color: `${item.colors}`,
          }}
        >
          {/* {item.name} */}
          <span className="trunc-text" title={item.name}>
            {item.name}
          </span>

          <img
            src={favStatus === 1 ? star : blankstar}
            style={{ width: "13px" }}
            onClick={(e) => {
              e.preventDefault();
              toggleFavorite(item.screen_id);
            }}
          />
        </Link>
      );
    } else {
      return (
        <>
          {/* {item.name} */}
          <span className="trunc-text" title={item.name}>
            {item.name}
          </span>

          <img
            src={favStatus === 1 ? star : blankstar}
            style={{ width: "12px", marginTop: "-10px" }}
            onClick={(e) => {
              e.preventDefault();
              toggleFavorite(item.screen_id);
            }}
          />
        </>
      );
    }
  };

  const renderSecondLevel = () => {
    if (item.children.length === 0 && item.ui_path) {
      return (
        <Link
          to={item.ui_path}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "80%",
            color: `${item.colors}`,
            marginLeft: "12px",
          }}
          onClick={() => setPagePath(currentHierarchy)}
        >
          {item.name}
          <img
            src={favStatus === 1 ? star : blankstar}
            style={{ width: "13px" }}
            onClick={(e) => {
              e.preventDefault();
              toggleFavorite(item.screen_id);
            }}
          />
        </Link>
      );
    } else {
      return item.name;
    }
  };

  const isLevel1Selected = level === 0 && selectedLvl1 === item.name;

  const itemStyle = {
    color: isLevel1Selected ? `${Colors.color14}` : `${Colors.color9}`,
    fontSize: level === 0 ? "16px" : "14.5px",
    display: "flex",
    alignItems: "center",
    width: "100%",
    cursor: "pointer",
    fontWeight: level === 0 ? "600" : "normal",
    marginBottom: level === 0 ? "10px" : "5px",
    // marginLeft: !item.children ? "10px" : "",
    marginLeft:
      level === 1 ? "4px" : level > 1 ? `${28 + (level - 1) * 12}px` : "0px",
  };

  return (
    <div style={{ marginLeft: level === 0 ? "0px" : "0px" }}>
      <div
        className="menu-item"
        style={{
          ...itemStyle,
        }}
        onClick={level === 0 ? handleLevel1Click : handleClick}
        onDoubleClick={level === 0 ? handleLevel1DoubleClick : undefined}
      >
        {item.children && item.children.length > 0 ? (
          level === 1 ? (
            <img
              src={arrowRightLevel2}
              className={isOpened ? "rotate-90" : ""}
              style={{
                width: "9px",
                marginRight: "4px",
                marginLeft: "13px",
              }}
              alt=""
            />
          ) : isOpened ? (
            <img
              src={arrowdown}
              style={{
                width: "9px",
                marginRight: "4px",
                marginLeft: "0px",
              }}
              alt=""
            />
          ) : (
            <img
              src={arrowright}
              style={{
                width: "9px",
                marginRight: "4px",
                marginLeft: "0px",
              }}
              alt=""
            />
          )
        ) : null}

        {!item.children ? renderLeaf() : renderSecondLevel()}
      </div>

      {item.children && (
        <div className={`sub-menu ${isOpened ? "" : "sub-menu--shrunk"}`}>
          {item.children.map((subitem) => (
            <Item
              key={subitem.name}
              item={subitem}
              level={level + 1}
              setPagePath={setPagePath}
              hierarchy={currentHierarchy}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default Item;

// =======================================================================================================
// SHASHI USING REDUX CODE

// import { Link } from "react-router-dom";
// import { useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import Swal from "sweetalert2"; // Import SweetAlert2

// import arrowdown from "../../../Assets/Images/Landing/arrowdown.png";
// import arrowright from "../../../Assets/Images/Landing/arrowright.png";
// import star from "../../../Assets/Images/Landing/star.png";
// import blankstar from "../../../Assets/Images/Landing/blankstar.png";
// import { toggleFavorite } from "../../../Redux/Fav/FavSlice"; // Import the thunk

// const Item = ({ item, level = 0, setPagePath, hierarchy = "" }) => {
//   const [isOpened, setIsOpened] = useState(false);
//   const dispatch = useDispatch();

//   // Select user and client IDs from Redux state
//   const { data } = useSelector((state) => state.landing);
//   const userId = data?.client_schema_name?.[6]?.[0]?.user_id;
//   const clientBrId = data?.client_schema_name?.[6]?.[0]?.client_branch_id;

//   // Check if the current item is in the favorites list
//   const favStatus = useSelector((state) =>
//     state.fav.data.some((fav) => fav.screen_id === item.screen_id)
//   );

//   const handleToggleFavorite = () => {
//     dispatch(
//       toggleFavorite({
//         userId,
//         clientBrId,
//         screen_id: item.screen_id,
//         isFavorite: favStatus, // Pass current favorite status
//       })
//     )
//       .unwrap()
//       .then(() => {
//         Swal.fire({
//           title: favStatus ? "Deleted!" : "Added!",
//           text: favStatus
//             ? "Deleted from favorites"
//             : "Added to favorites",
//           icon: "success",
//           timer: 3000, // Show for 3 seconds
//           showConfirmButton: false,
//         });
//       })
//       .catch((error) => {
//         console.error("Error updating favorite status", error);
//         Swal.fire({
//           title: "Error",
//           text: "Error updating favorite status",
//           icon: "error",
//           timer: 3000, // Show for 3 seconds
//           showConfirmButton: false,
//         });
//       });
//   };

//   const currentHierarchy = hierarchy
//     ? `${hierarchy} > ${item.name}`
//     : item.name;

//   const handleClick = () => {
//     setIsOpened(!isOpened);
//     if (!item.children && item.ui_path) {
//       setPagePath(currentHierarchy);
//     }
//   };

//   const renderLeaf = () => {
//     if (item.ui_path) {
//       return (
//         <Link
//           to={item.ui_path}
//           style={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//             width: "80%",
//             color: `${item.colors}`,
//           }}
//         >
//           {item.name}
//           <img
//             src={favStatus ? star : blankstar}
//             style={{ width: "13px" }}
//             onClick={(e) => {
//               e.preventDefault();
//               handleToggleFavorite();
//             }}
//           />
//         </Link>
//       );
//     } else {
//       return (
//         <>
//           {item.name}
//           <img
//             src={favStatus ? star : blankstar}
//             style={{ width: "12px", marginTop: "-10px" }}
//             onClick={(e) => {
//               e.preventDefault();
//               handleToggleFavorite();
//             }}
//           />
//         </>
//       );
//     }
//   };

//   const renderSecondLevel = () => {
//     if (item.children.length === 0 && item.ui_path) {
//       return (
//         <Link
//           to={item.ui_path}
//           style={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//             width: "80%",
//             color: `${item.colors}`,
//             marginLeft: "12px",
//           }}
//           onClick={() => setPagePath(currentHierarchy)}
//         >
//           {item.name}
//           <img
//             src={favStatus ? star : blankstar}
//             style={{ width: "13px" }}
//             onClick={(e) => {
//               e.preventDefault();
//               handleToggleFavorite();
//             }}
//           />
//         </Link>
//       );
//     } else {
//       return item.name;
//     }
//   };

//   const itemStyle = {
//     color: item.colors,
//     fontSize: level === 0 ? "16px" : "14.5px",
//     display: "flex",
//     alignItems: "center",
//     width: "100%",
//     cursor: "pointer",
//     fontWeight: level === 0 ? "600" : "normal",
//     marginBottom: level === 0 ? "10px" : "5px",
//     marginLeft: !item.children ? "10px" : "",
//   };

//   return (
//     <div style={{ marginLeft: level === 0 ? "0px" : "10px" }}>
//       <div className="menu-item" onClick={handleClick} style={itemStyle}>
//         {item.children && item.children.length > 0 ? (
//           isOpened ? (
//             <img src={arrowdown} style={{ width: "11px" }} />
//           ) : (
//             <img src={arrowright} style={{ width: "9px" }} />
//           )
//         ) : null}
//         {!item.children ? renderLeaf() : renderSecondLevel()}
//       </div>

//       {item.children && (
//         <div className={`sub-menu ${isOpened ? "" : "sub-menu--shrunk"}`}>
//           {item.children.map((subitem) => (
//             <Item
//               key={subitem.name}
//               item={subitem}
//               level={level + 1}
//               setPagePath={setPagePath}
//               hierarchy={currentHierarchy}
//             />
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };

// export default Item;

// ========================================================================================================

// import { Link, useLocation } from "react-router-dom";
// import { useState, useEffect } from "react";
// import axios from "axios";
// import Swal from "sweetalert2";

// import arrowdown from "../../../Assets/Images/Landing/arrowdown.png";
// import arrowright from "../../../Assets/Images/Landing/arrowright.png";
// import star from "../../../Assets/Images/Landing/star.png";
// import blankstar from "../../../Assets/Images/Landing/blankstar.png";
// import { API_BASE_URL } from "../../../Config/Config";

// import { useSelector } from "react-redux";

// const Item = ({ item, level = 0, setPagePath, hierarchy = "" }) => {
//   const [isOpened, setIsOpened] = useState(false);
//   const [favStatus, setFavStatus] = useState(item.my_fav);

//   const location = useLocation();

//   const { data } = useSelector((state) => state.landing);
//   const userId = data && data.client_schema_name[6][0].user_id;
//   const clientBrId = data && data.client_schema_name[6][0].client_branch_id;

//   useEffect(() => {
//     // Function to set page path based on URL
//     const updatePagePathFromURL = () => {
//       const path = location.pathname.split("/").filter((segment) => segment);
//       if (path.length > 0) {
//         const currentHierarchy = path.join(" > ");
//         console.log("Setting page path to:", currentHierarchy); // Debugging log
//         setPagePath(currentHierarchy);
//       }
//     };

//     console.log("Running useEffect"); // Debugging log
//     updatePagePathFromURL();
//   }, [location, setPagePath]);

//   useEffect(() => {
//     console.log("Item component mounted"); // Log to check if component mounts
//   }, []);

//   const toggleFavorite = async (screen_id) => {
    // REPLACED
//     try {
//       if (favStatus === 1) {
//         await axios.post(
//           `${API_BASE_URL}/coaching-collaborator-api/api/v1/manage-user-favourite?operation=delete&user_id=${userId}&screen_id=${item.screen_id}&client_br_id=${clientBrId}`
//         );
//         setFavStatus(0);
//         Swal.fire({
//           title: "Deleted!",
//           text: "Deleted from favorites",
//           icon: "success",
//           timer: 3000,
//           showConfirmButton: false,
//         });
//       } else {
//         await axios.post(
//           `${API_BASE_URL}/coaching-collaborator-api/api/v1/manage-user-favourite?operation=create&user_id=${userId}&screen_id=${item.screen_id}&client_br_id=${clientBrId}`
//         );
//         setFavStatus(1);
//         Swal.fire({
//           title: "Added!",
//           text: "Added to favorites",
//           icon: "success",
//           timer: 3000,
//           showConfirmButton: false,
//         });
//       }
//       setTimeout(() => {
//         window.location.reload();
//       }, 1300);
//     } catch (error) {
//       console.error("Error updating favorite status", error);
//       Swal.fire({
//         title: "Error",
//         text: "Error updating favorite status",
//         icon: "error",
//         timer: 3000,
//         showConfirmButton: false,
//       });
//     }
//   };

//   const currentHierarchy = hierarchy ? `${hierarchy} > ${item.name}` : item.name;

//   const handleClick = () => {
//     setIsOpened(!isOpened);
//     if (!item.children && item.ui_path) {
//       console.log("Setting page path on click:", currentHierarchy); // Log path on click
//       setPagePath(currentHierarchy);
//     }
//   };

//   const renderLeaf = () => {
//     if (item.ui_path) {
//       return (
//         <Link
//           to={item.ui_path}
//           style={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//             width: "80%",
//             color: `${item.colors}`,
//           }}
//         >
//           {item.name}
//           <img
//             src={favStatus === 1 ? star : blankstar}
//             style={{ width: "13px" }}
//             onClick={(e) => {
//               e.preventDefault();
//               toggleFavorite(item.screen_id);
//             }}
//           />
//         </Link>
//       );
//     } else {
//       return (
//         <>
//           {item.name}
//           <img
//             src={favStatus === 1 ? star : blankstar}
//             style={{ width: "12px", marginTop: "-10px" }}
//             onClick={(e) => {
//               e.preventDefault();
//               toggleFavorite(item.screen_id);
//             }}
//           />
//         </>
//       );
//     }
//   };

//   const itemStyle = {
//     color: item.colors,
//     fontSize: level === 0 ? "16px" : "14.5px",
//     display: "flex",
//     alignItems: "center",
//     width: "100%",
//     cursor: "pointer",
//     fontWeight: level === 0 ? "600" : "normal",
//     marginBottom: level === 0 ? "10px" : "5px",
//     marginLeft: !item.children ? "10px" : "",
//   };

//   return (
//     <div style={{ marginLeft: level === 0 ? "0px" : "10px" }}>
//       <div className="menu-item" onClick={handleClick} style={itemStyle}>
//         {item.children ? (
//           isOpened ? (
//             <img src={arrowdown} style={{ width: "11px" }} />
//           ) : (
//             <img src={arrowright} style={{ width: "9px" }} />
//           )
//         ) : null}
//         {!item.children ? renderLeaf() : item.name}
//       </div>

//       {item.children && (
//         <div className={`sub-menu ${isOpened ? "" : "sub-menu--shrunk"}`}>
//           {item.children.map((subitem) => (
//             <Item
//               key={subitem.name}
//               item={subitem}
//               level={level + 1}
//               setPagePath={setPagePath}
//               hierarchy={currentHierarchy}
//             />
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };

// export default Item;